import React, { useEffect, useState } from "react";
import "./style.css";
import { useNavigate, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import { useSelector } from "react-redux";
import Navbar from "react-bootstrap/Navbar";
import NavbarActions from "./components/NavbarActions";
import NavbarCenterMenu from "./components/NavbarCenterMenu";
import NavbarOverlays from "./components/NavbarOverlays";
import { useNavbarRealtime } from "../../hooks/navbar/useNavbarRealtime";
import { useNavbarRouteLabel } from "../../hooks/navbar/useNavbarRouteLabel";
import { useMarkWelcomeModalSeenMutation } from "../../features/user/userApiSlice";

const Navbarr = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { name } = useSelector((state) => state.user);
  const [showLogout, setShowLogout] = useState(false);
  const [lgShowNotifications, setLgShowNotifications] = useState(false);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [markWelcomeModalSeen] = useMarkWelcomeModalSeenMutation();
  const { notifications, setNotifications, setUnreadMsgCount, unreadMsgCount } =
    useNavbarRealtime({ userId: name?._id });
  const textToShow = useNavbarRouteLabel();

  useEffect(() => {
    // Only display welcome modal for authenticated users
    if (!name?._id) return;

    const userId = name._id;
    const hasSeenInUserObj = name?.hasSeenWelcomeModal === true;
    const hasSeenInLocalStorage =
      localStorage.getItem(`hasSeenWelcomeModal_${userId}`) === "true";
    const hasSeenInSession =
      sessionStorage.getItem(`hasSeenWelcomeModal_${userId}`) === "true" ||
      sessionStorage.getItem("hasSeenWelcomeModal") === "true";

    // If user has already seen the welcome modal, do not show it again
    if (hasSeenInUserObj || hasSeenInLocalStorage || hasSeenInSession) {
      if (hasSeenInUserObj && !hasSeenInLocalStorage) {
        try {
          localStorage.setItem(`hasSeenWelcomeModal_${userId}`, "true");
        } catch (e) {
          console.debug(e);
        }
      }
      if (!hasSeenInUserObj && (hasSeenInLocalStorage || hasSeenInSession)) {
        markWelcomeModalSeen({ userId })
          .unwrap()
          .catch(() => {});
      }
      return;
    }

    // New user who hasn't seen the modal yet: show it once
    const timer = setTimeout(() => {
      setShowWelcomeModal(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, [name?._id, name?.hasSeenWelcomeModal, markWelcomeModalSeen]);

  if (location.pathname === "/messages") return null;

  return (
    <>
      <NavbarOverlays
        lgShowNotifications={lgShowNotifications}
        name={name}
        notifications={notifications}
        setLgShowNotifications={setLgShowNotifications}
        setNotifications={setNotifications}
        setShowLogout={setShowLogout}
        setShowWelcomeModal={setShowWelcomeModal}
        showLogout={showLogout}
        showWelcomeModal={showWelcomeModal}
      />

      <Container fluid className="nav-absolute container-border-b px-2 px-md-3">
        <Navbar
          collapseOnSelect
          expand="lg"
          className="navbar-responsive bg-white w-100 pb-1 pt-1"
        >
          <Container fluid className="px-0">
            {/* LOGO */}
            <Navbar.Brand
              className="d-flex align-items-center py-0"
              onClick={() =>
                location.pathname.startsWith("/SellingSide")
                  ? navigate("/SellingSide")
                  : navigate("/BuyingSide")
              }
            >
              <p className="logo m-0 fs-7">SELECTEZI</p>
            </Navbar.Brand>

            {/* TOGGLER (Hidden via CSS, kept for Bootstrap structural consistency) */}
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              className="d-none"
            />

            {/* CENTER NAVIGATION MENU */}
            <Navbar.Collapse id="responsive-navbar-nav">
              <NavbarCenterMenu
                pathname={location.pathname}
                textToShow={textToShow}
              />
            </Navbar.Collapse>

            {/* RIGHT ICONS, SEARCH & DROPDOWN */}
            <NavbarActions
              className="navbar-mobile-actions"
              notifications={notifications}
              onLogout={() => setShowLogout(true)}
              onMessages={() => {
                setUnreadMsgCount(0);
                navigate("/messages", {
                  state: { returnTo: location.pathname },
                });
              }}
              onNotifications={() => setLgShowNotifications(true)}
              unreadMsgCount={unreadMsgCount}
              user={name}
            />
          </Container>
        </Navbar>
      </Container>
    </>
  );
};

export default Navbarr;
